import { inject, Injectable } from '@angular/core';
import { environment } from '../../environment/environment';
import { StorageService } from './storage.service';


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  _storage: StorageService = inject(StorageService);

  authorization(sendBearer = true) {
    const token = this._storage.token;
    const auth = {
      'Authorization': environment.FINGER_PRINT,
      "api_key": environment.apiUrl.includes('dev') ? environment.API_KEY_2 : environment.API_KEY,
      "platform": '' + this._storage.deviceDetail(3),
      "timezone": '' + this._storage.deviceDetail(4),
      "language": 'en',
      'Content-Type': "application/json",
      'Access-Control-Allow-Origin': '*',
    }
    return auth;
  }




  clearToken(): void {
    this._storage.clearToken();
  }
}


